import React from 'react'
import { retrieveConfig } from '../../config/config'

const CSP_NONCE = '8IBTHwOdqNKAWeKl7plt8g=='

export default class ModalHeader extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            config: {
                showLogo: true,
                showTitle: true,
            },
            showCloseButton: false,
        }
    }

    async componentDidMount() {
        try {
            const selectedConfig = await retrieveConfig()
            if (selectedConfig) {
                this.setState({ config: selectedConfig })
            }
        } catch (error) {
            console.error('Error retrieving config:', error)
        }

        this.closeButtonTimer = setTimeout(() => {
            this.setState({ showCloseButton: true })
        }, 3000)
    }

    componentWillUnmount() {
        if (this.closeButtonTimer) {
            clearTimeout(this.closeButtonTimer)
        }
    }

    toggle = () => {
        window?.DataMesh?.destroy()

        document.dispatchEvent(
            new CustomEvent('closePaymentModal', {
                detail: { closed: true },
            }),
        )
    }

    render() {
        const mergedConfig = { ...this.props.config, ...this.state.config }
        const { showLogo = true, showTitle = true } = mergedConfig

        const cdnHost = window.env.REACT_APP_CDN_HOST
        const urlRoot = cdnHost + '/app'

        const logoUrl = this.state.config?.logo?.url.replace('%CDN_HOST%', urlRoot)

        const primaryColor = this.state.config?.colorTheme?.primaryColor ?? '#334155'
        const paymentOptionsText =
            this.state.config?.header?.title ?? this.state.config?.form?.paymentOptionsText ?? 'Payment Options'

        return (
            <div className="modal-header w-100">
                <style nonce={CSP_NONCE}>
                    {`.modal-header-theme{--modal-primary-color:${primaryColor}}@media(max-width:312px){.modal-logo{display:none!important}.modal-header .title-container{flex-basis:100%!important;text-align:left!important;padding-left:0!important}.modal-header .modal-title{white-space:normal!important;padding:0!important}}`}
                </style>
                <div className="modal-header-theme modal-header-bar">
                    <div className="modal-logo-container">
                        {showLogo && (
                            <div className="modal-logo">
                                <img src={logoUrl} alt="Logo" className="modal-logo-img" />
                            </div>
                        )}
                    </div>

                    <div className="title-container">
                        {showTitle && <h2 className="modal-title modal-primary-text">{paymentOptionsText}</h2>}
                    </div>

                    <div className="modal-header-actions">
                        {!this.props.isSdkPage && (
                            <button
                                className={`modal-close-btn modal-close-btn-header top-0 right-0 z-10 background-transparent font-bold uppercase text-sm outline-none focus:outline-none ease-linear transition-all duration-150 hover:text-red${
                                    this.state.showCloseButton ? ' modal-close-btn--visible' : ' modal-close-btn--hidden'
                                }`}
                                type="button"
                                aria-label="Close"
                                title="Close"
                                onClick={() => this.toggle()}
                            >
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        className="modal-close-icon-path"
                                        d="M14.3556 0.00444444C13.9109 0.00444444 13.4973 0.177778 13.186 0.488889L8.00945 5.66222L2.82843 0.488889C2.51713 0.177778 2.09909 0.00444444 1.65881 0.00444444C1.21854 0.00444444 0.796053 0.177778 0.484747 0.488889C0.173442 0.8 0 1.21778 0 1.65778C0 2.09778 0.173442 2.51556 0.484747 2.82667L5.66132 8L0.484747 13.1778C0.173442 13.4889 0 13.9067 0 14.3467C0 14.7867 0.173442 15.2044 0.484747 15.5156C0.796053 15.8267 1.21409 16 1.65437 16C2.09464 16 2.51268 15.8267 2.82399 15.5156L8.00056 10.3422L13.1771 15.5156C13.4884 15.8267 13.9065 16 14.3467 16C14.787 16 15.2051 15.8267 15.5164 15.5156C16.1612 14.8711 16.1612 13.8178 15.5164 13.1733L10.3398 8L15.5164 2.82667C16.1612 2.18222 16.1612 1.13333 15.5164 0.484444C15.2051 0.173333 14.787 0 14.3467 0L14.3556 0.00444444Z"
                                    />
                                </svg>
                            </button>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}
